import React from "react";

/**
 * Webo24 — WebOrganization 24/7
 * Logo concept: "W24" monogram inside a 24h circular sweep.
 *  • Outer ring = perpetual cycle (24/7 organization)
 *  • Stylized W = web / workflow
 *  • "24" badge = always-on
 *  • Warm gradient (terracotta → gold) keeps brand continuity with the gestionale palette
 */
export default function Logo({ size = 44, withText = true, textClassName = "" }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Webo24 — WebOrganization 24"
      >
        <defs>
          <linearGradient id="wb-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#B46B52" />
            <stop offset="100%" stopColor="#D9A05B" />
          </linearGradient>
          <linearGradient id="wb-grad-soft" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#F4EDE3" />
          </linearGradient>
        </defs>

        {/* Background disc */}
        <circle cx="32" cy="32" r="30" fill="url(#wb-grad-soft)" />

        {/* 24h sweep arc — open at top, with a small dot marking "now" */}
        <path
          d="M 32 4 A 28 28 0 1 1 12 12"
          stroke="url(#wb-grad)"
          strokeWidth="2.2"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="32" cy="4" r="2.4" fill="#D9A05B" />

        {/* Stylized W — three peaks ending in clean strokes */}
        <path
          d="M 16 24 L 22 44 L 28 30 L 34 44 L 40 24"
          stroke="url(#wb-grad)"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />

        {/* "24" badge — small superscript chip */}
        <g transform="translate(42 22)">
          <rect x="-1" y="-1" width="18" height="14" rx="4" fill="#B46B52" />
          <text
            x="8"
            y="9.5"
            textAnchor="middle"
            fontSize="9"
            fontWeight="700"
            fill="#FFFFFF"
            fontFamily="ui-sans-serif, system-ui, sans-serif"
            letterSpacing="0.5"
          >
            24
          </text>
        </g>
      </svg>
      {withText && (
        <div className={`leading-none ${textClassName}`}>
          <div className="font-brand text-2xl font-medium" style={{ color: "#3D2B1F" }}>
            Webo<span style={{ color: "#B46B52" }}>24</span>
          </div>
          <div className="label-tag mt-1">WebOrganization 24/7</div>
        </div>
      )}
    </div>
  );
}
